export default __webpack_public_path__ + "static/media/Academic.273fb70f.png";